<template>
  <button class="ui button checked" v-if="checked" @click.prevent="toggle"><i class="heart icon"></i>問い合わせリストに追加済</button>
  <button class="ui button" v-else  @click.prevent="toggle"><i class="heart outline icon"></i>問い合わせリストに追加</button>
</template>

<script>

export default {
    data: function() {
        return {
            checked: false
        };
    },
    props: {
        shopId: {
            require: true,
            type: Number
        }
    },
    created: function() {
        this.checked = _.includes(this.selectedShops(), this.shopId);
    },
    methods: {
        toggle: function() {
            var shops = this.selectedShops();
            if (!this.checked && shops.length >= 10) {
                alert('まとめて問い合わせリストに追加できるのは10件までです');
                return;
            }
            this.checked = !this.checked;
            _.remove(shops, function(shopId) {
                return this.shopId === shopId;
            }.bind(this));
            if (this.checked) {
                shops.push(this.shopId);
            }
            this.setShops(shops);
            this.$root.selectedShopCount = shops.length;
        },
    }
};
</script>
